import { ClockIcon, MapPinIcon, PhoneIcon } from "@heroicons/react/24/outline";
import { MailIcon, InfoIcon, Clock3 } from "lucide-react";

export default function Contact() {
    return (
        <div className="flex flex-col items-center justify-center bg-gradient-to-br from-indigo-50 via-white to-blue-100 py-14 px-4">

            {/* Tiêu đề */}
            <div className="text-center mb-10">
                <h1 className="text-4xl font-extrabold mb-3 text-gray-800 drop-shadow-sm">
                    Liên hệ với chúng tôi
                </h1>
                <p className="text-lg max-w-2xl mx-auto text-gray-600">
                    Nếu bạn có bất kỳ câu hỏi, góp ý hoặc cần hỗ trợ, hãy liên hệ với chúng tôi qua các thông tin sau.
                    Chúng tôi luôn sẵn sàng hỗ trợ bạn!
                </p>
            </div>

            {/* Card */}
            <div className="bg-white/80 backdrop-blur-xl border border-gray-200 shadow-2xl rounded-3xl p-10 w-full max-w-2xl transition-all duration-300 hover:shadow-[0_8px_30px_rgba(0,0,0,0.12)]">

                {/* Thông tin liên hệ */}
                <div className="mb-8">
                    <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-3">
                        <InfoIcon className="w-6 h-6 text-blue-600" />
                        Thông tin liên hệ
                    </h2>

                    <div className="space-y-3 pl-1">
                        <p className="flex items-center gap-3 text-gray-700">
                            <MailIcon className="w-6 h-6 text-blue-600" />
                            <span><strong>Email:</strong> tthau2004@gmail.com</span>
                        </p>

                        <p className="flex items-center gap-3 text-gray-700">
                            <PhoneIcon className="w-6 h-6 text-green-600" />
                            <span><strong>Điện thoại:</strong> <em>Đang cập nhật</em></span>
                        </p>

                        <p className="flex items-center gap-3 text-gray-700">
                            <MapPinIcon className="w-6 h-6 text-red-500" />
                            <span><strong>Địa chỉ:</strong> Thành phố Thủ Đức, TP.HCM</span>
                        </p>
                    </div>
                </div>

                {/* Giờ làm việc */}
                <div>
                    <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-3">
                        <Clock3 className="w-6 h-6 text-yellow-500" />
                        Giờ làm việc
                    </h2>

                    <div className="space-y-3 pl-1">
                        <p className="flex items-center gap-3 text-gray-700">
                            <ClockIcon className="w-6 h-6 text-yellow-500" />
                            Thứ Hai - Thứ Sáu: 8:00 AM - 6:00 PM
                        </p>

                        <p className="flex items-center gap-3 text-gray-500">
                            <ClockIcon className="w-6 h-6 text-gray-400" />
                            Thứ Bảy - Chủ Nhật: Đóng cửa
                        </p>
                    </div>
                </div>

            </div>
        </div>
    );
}